// extracted by mini-css-extract-plugin
export default {"root":"uF44qP","root2":"zXz3Tz","input-area":"qGFEXj","inputArea":"qGFEXj","send-button":"Bq0qCp","sendButton":"Bq0qCp","textarea":"njBMaZ","prompts":"uRtINT"};